var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles),attrs:{"id":_vm.$style.title}},[_c('h2',[_vm._v(_vm._s(_vm.main_title))]),_c('small',[_vm._v(_vm._s(_vm.sub_title))])])}
var staticRenderFns = []

export { render, staticRenderFns }